module.exports = __webpack_public_path__ + "img/logo-the-lobby-nesplein--dark.0ad579448d41b7770151ce615114e94d.svg";